<template>
<div>

    <div class="label">
        {{label}}
    </div>

    <div class="chip_row">

        <div class="chip_container">
            <v-chip
                v-for="(item, index) in value"
                disabled
                style="margin-right: 5px; margin-bottom: 5px;"
                :key="index"
            >
                {{getLabel(item)}}
            </v-chip>
        </div>

        <m-edit-menu
            v-if="!read_only"
            :menu_items="menu_items"
            v-on:menu-action="onMenuAction($event)"
         />

    </div>

    <m-edit-chip-dialog
        :title="dialog_title"
        :possible_values="possible_values"
        ref="edit_dialog"
        v-on:ok="setValueFromDialog"
    />

    
</div>
</template>

<script>
export default {
    props: {
        label: {
            type: String,
            default: function () { return 'label'; }
        },

        dialog_title: {
            type: String,
            default: function () { return 'Edit'; }
        },

        value: {
            type: Array,
            default: function() { return []; }
        },

        possible_values: {
            type: Array,
            default: function() { return []; }
        },

        menu_items: {
            type: Array,
            default: function() { return []; }
        },

        read_only: {
            type: Boolean,
            default: function() { return false; }
        },
    },

    methods: {
        onMenuAction(menu_item)
        {
            if ( menu_item.event == 'edit' )
            {
                this.onEdit();
                return;
            }

            this.$emit(menu_item.event, menu_item);
        },

        onEdit() 
        {
           this.$refs['edit_dialog'].showDialog(this.value);
        },

        getLabel(item)
        {
            return item.text;
        },

        setValueFromDialog(new_value)
        {
            this.$emit('input',new_value);
        }
    },
}
</script>

<style lang="scss" scoped>
.label
{
    color: rgba(0,0,0,0.38);
    font-family: 'Roboto', sans-serif;
    font-size: 12px;
    font-weight: 400;
}

.chip_row
{
    display: flex;
}

.chip_container
{
    flex-grow: 1;
}

.edit_container
{
    flex-grow: 0;
}
</style>